module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-parts-slider",
    class: {
      'component-parts-slider_bg': !_vm.useTag
    }
  }, [_c('ul', {
    staticClass: "component-parts-slider__images",
    class: {
      'component-parts-slider__images_bg': !_vm.useTag
    }
  }, _vm._l((_vm.images), function(item, index) {
    return _c('li', {
      staticClass: "component-parts-slider__image",
      class: {
        'component-parts-slider__image_bg': !_vm.useTag, 'component-parts-slider__image_current': _vm.curr === index
      },
      style: (!_vm.useTag && {
        backgroundImage: item ? ("url(" + item + ")") : false
      })
    })
  }), 0), (_vm.images.length > 1) ? [_c('CardSliderArrow', {
    attrs: {
      "color": _vm.color
    },
    on: {
      "changeImage": _vm.click
    }
  }), _c('CardSliderNavDots', {
    attrs: {
      "dots": _vm.images,
      "active": _vm.curr
    },
    on: {
      "clickDot": _vm.click
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1182deeb","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/slider/images/CardSlider.vue
// module id = dcd2355d069ceab93482
// module chunks = 0